import {create} from 'zustand';
import {createJSONStorage, persist} from 'zustand/middleware';

export const STORAGE_KEYS = {
  session: 'auth-session-storage',
} as const;

export type StorageKeyType = keyof typeof STORAGE_KEYS;

export interface Session {
  accessToken: string;
  expiresAt: number;
  refreshToken: string;
  role: number;
  userId: string;
}

export interface AuthState {
  session: Session | null;
  setSession: (session: Session) => void;
  clearSession: () => void;
  viewMode: 'events' | 'places';
  onChangeViewMode: (mode: 'events' | 'places') => void;
  clearViewMode: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      session: null,
      setSession: session => set({session}),
      clearSession: () => set({session: null}),
      viewMode: 'events',
      onChangeViewMode: mode => set({viewMode: mode}),
      clearViewMode: () => set({viewMode: 'events'}),
    }),
    {
      name: STORAGE_KEYS.session,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
